import { useEffect } from "react";
import { Platform } from "react-native";

// This hook fixes some seriously annoying intemediary elements and styles
// injected by react-native-screens post version 3.29.0 which break
// scrolling and layout on web.
//
// We should use this hook in all Layout files in the app, e.g.
// HomepageLayout, Layout, etc.
export function useFixLayoutChain(id: string) {
  if (Platform.OS !== "web") return;

  useEffect(() => {
    const stopAtId = "appScrollView"; // The id of the element where we stop fixing the layout chain
    const start = document.getElementById(id);
    const stopAt = document.getElementById(stopAtId);
    if (!start) {
      console.warn(`[useFixLayoutChain] Element with id "${id}" not found.`);
      return;
    }

    if (!stopAt) {
      console.warn(
        `[useFixLayoutChain] Stop element with id "${stopAtId}" not found.`
      );
      return;
    }

    let el = start.parentElement;

    while (el && el !== stopAt.parentElement) {
      if (el.id === stopAtId) break;

      // Clear any class-based styling
      el.className = "";

      // Reset inline styles except optional debug background
      el.removeAttribute("style");

      el = el.parentElement;
    }

    console.log(`[useFixLayoutChain] Fully patched layout chain for #${id}`);
  }, [id]);
}
